//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const UserMigrationQaDelay: FeatureFlag = {"Id":"UserMigrationQaDelay","Label":"(QA)[10.19]Add delay before user migration","Impact":"Delay user migration by 90 seconds to test long-running migration behavior.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
